import BulkSaleModal from '../../../components/bulk/BulkSaleModal';

const CartaBulkSaleModal = (props) => (
  <BulkSaleModal
    variant="carta"
    testIdPrefix="carta-bulk-modal"
    confirmLabel="Agregar al pedido"
    {...props}
  />
);

export default CartaBulkSaleModal;
